import React from 'react';
import { Link } from 'react-router-dom';

const SecurityAndDataProtectionPage = () => {
    return (
        <div className="min-h-screen bg-purple-50">
            <div className="max-w-4xl mx-auto px-6 py-12">
                <div className="text-center mb-12">
                    <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Security and Data Protection
                    </h1>

                    <div className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed">
                        <p className="mb-6">
                            CampusMind blocks sensitive data before it leaves your screen — your privacy, proactively protected
                        </p>
                    </div>
                </div>

                {/* Architecture Diagrams */}
                <div className="mb-12">
                    <div className="space-y-8">
                        {/* First Diagram */}
                        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
                            <div className="text-center mb-6">
                                <h2 className="text-2xl font-bold text-gray-900 mb-2">Architecture Overview</h2>
                                <p className="text-gray-700">Comprehensive system architecture and data flow</p>
                            </div>
                            <div className="flex justify-center">
                                <img
                                    src="/Picture1.png"
                                    alt="CampusMind Architecture Diagram 1"
                                    className="w-full max-w-6xl rounded-lg shadow-md"
                                />
                            </div>
                        </div>

                        {/* Second Diagram */}
                        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
                            <div className="text-center mb-6">
                                <h2 className="text-2xl font-bold text-gray-900 mb-2">Infrastructure Components</h2>
                                <p className="text-gray-700">Data protection and security implementation</p>
                            </div>
                            <div className="flex justify-center">
                                <img
                                    src="/Picture2.png"
                                    alt="CampusMind Security Framework Diagram"
                                    className="w-full max-w-6xl rounded-lg shadow-md"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Test Section */}
                <div className="text-center mb-8">
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
                        Test it for yourself
                    </h2>
                    <p className="text-lg text-gray-700 mb-8">
                        Click a sample question from the list below to see how CampusMind handles information securely.
                    </p>
                </div>

                {/* Security screenshot */}
                <div className="bg-white rounded-lg p-8 shadow-md mb-12 text-center">
                    <img
                        src="/security.jfif"
                        alt="CampusMind security and data protection demonstration"
                        className="max-w-full h-auto rounded-lg shadow-md mx-auto"
                    />
                </div>

                <div className="mb-12">
                    <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                        Try the prompts
                    </h3>
                </div>

                <div className="flex justify-center space-x-4">
                    <Link
                        to="/"
                        className="bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-colors duration-200"
                    >
                        Back to Start
                    </Link>
                    <Link
                        to="/explore-marketplace"
                        className="bg-purple-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-purple-800 transition-colors duration-200"
                    >
                        Explore Marketplace
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default SecurityAndDataProtectionPage; 
